import { requestInstanceV2 } from '@/helpers/requestInstanceV2';
import { API_DOMAINS } from '@/constants';

export interface MultipartUploadPart {
	partNumber: number;
	url: string;
}

export interface CompletedMultipartUploadPart {
	partNumber: number;
	eTag: string;
}

interface InitiateMultipartUploadArgs {
	mimeType: string;
	filename: string;
	fileSize: number;
	token: string;
}

interface InitiateMultipartUploadResponse {
	fileId: string;
	partSize: number;
	parts: MultipartUploadPart[];
}

interface CompleteMultipartUploadArgs {
	fileId: string;
	parts: CompletedMultipartUploadPart[];
	token: string;
}

interface CompleteMultipartUploadResponse {
	viewUrl: string;
}

interface AbortMultipartUploadArgs {
	fileId: string;
	token: string;
}

export const VideoConverterApiService = {
	async initiateMultipartUpload({
		mimeType,
		filename,
		fileSize,
		token,
	}: InitiateMultipartUploadArgs) {
		const response = await requestInstanceV2<
			{ mimeType: string; filename: string; fileSize: number },
			InitiateMultipartUploadResponse
		>({
			url: API_DOMAINS.UPLOAD_VIDEO_MULTIPART,
			method: 'post',
			data: { mimeType, filename, fileSize },
			token,
		});
		return response.data;
	},

	async completeMultipartUpload({
		fileId,
		parts,
		token,
	}: CompleteMultipartUploadArgs) {
		const response = await requestInstanceV2<
			{ parts: CompletedMultipartUploadPart[] },
			CompleteMultipartUploadResponse
		>({
			url: `${API_DOMAINS.UPLOAD_VIDEO_MULTIPART}/${fileId}/complete`,
			method: 'post',
			data: { parts },
			token,
		});
		return response.data;
	},

	async abortMultipartUpload({ fileId, token }: AbortMultipartUploadArgs) {
		await requestInstanceV2({
			url: `${API_DOMAINS.UPLOAD_VIDEO_MULTIPART}/${fileId}`,
			method: 'delete',
			token,
		});
	},
};
